import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ToggleComponent } from './toggle/toggle.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-cookies-type',
    imports: [
        ReactiveFormsModule,
        ToggleComponent,
        TranslatePipe
    ],
    templateUrl: './cookie-type.component.html',
})
export class CookieTypeComponent {
  public readonly type = input.required<string>();
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
  public readonly control = input.required<FormControl>();

}
